// XNGAGE CONFIDENTIAL
// __________________________
//
// Copyright (C) 2023 Xngage - All Rights Reserved
//
// All code or information contained herein is, and remains the
// property of Xngage LLC and its customers.  The intellectual
// and technical concepts contained are proprietary to Xngage LLC
// and may be covered by U.S. and Foreign Patents, patents in
// process, and are protected by trade secret or copyright law.
// Dissemination of this information or reproduction of this material
// is strictly forbidden unless prior written permission is obtained
// from Xngage LLC.
//

import {
    ApiHandler,
    createHandlerChainRunner,
    HasOnSuccess,
    markSkipOnCompleteIfOnSuccessIsSet,
} from "@insite/client-framework/HandlerCreator";
import { getMaintenanceStatus, MaintenanceModel } from "@keller/App/Services/MaintenanceService";

type HandlerType = ApiHandler<HasOnSuccess<MaintenanceModel>, MaintenanceModel>;

export const DispatchBeginLoadMaintenance: HandlerType = props => {
    props.dispatch({
        type: "xMaintenance/BeginLoadMaintenance",
    } as any);
};

export const RequestDataFromApi: HandlerType = async props => {
    try {
        props.apiResult = await getMaintenanceStatus();
    } catch (error) {
        props.dispatch({
            type: "xMaintenance/FailedLoadMaintenance",
        } as any);
        return false;
    }
};

export const DispatchCompleteLoadMaintenance: HandlerType = props => {
    props.dispatch({
        type: "xMaintenance/CompleteLoadMaintenance",
        data: props.apiResult,
    } as any);
};

export const ExecuteOnSuccessCallback: HandlerType = props => {
    markSkipOnCompleteIfOnSuccessIsSet(props);
    props.parameter.onSuccess?.(props.apiResult);
};

export const chain = [
    DispatchBeginLoadMaintenance,
    RequestDataFromApi,
    DispatchCompleteLoadMaintenance,
    ExecuteOnSuccessCallback,
];

const loadMaintenance = createHandlerChainRunner(chain, "LoadMaintenance");

export default loadMaintenance;
